export default __webpack_public_path__ + "static/media/left_fish.5a00561f.svg";